import { render, staticRenderFns } from "./EmailDeliveryStatus.vue?vue&type=template&id=96831f6c&scoped=true"
import script from "./EmailDeliveryStatus.vue?vue&type=script&lang=js"
export * from "./EmailDeliveryStatus.vue?vue&type=script&lang=js"
import style0 from "./EmailDeliveryStatus.vue?vue&type=style&index=0&id=96831f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96831f6c",
  null
  
)

export default component.exports